import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { DateElement_element$data } from "../../__generated__/DateElement_element.graphql";
import { DateElement_screener$data } from "../../__generated__/DateElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: DateElement_element$data;
  screener: DateElement_screener$data;
} & CommonElementProps;
const DateElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(DateElement, {
  element: graphql`
    fragment DateElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment DateElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
